<style lang="less">
    .page_con.no{
        .page404{
            img{
                width: 80%;
                height: auto;
                display: block;
                margin: 10vh auto 10vh;
            }
            p{
                text-align: center;
            }
            div.gohome{
                width: 30vw;
                margin:5vh auto 0;
                padding:1vh 5vw;
                border:.02rem solid #EB612B;
                border-radius: 50px;
                text-align: center;
                color:#fff;
                background: #F5B341;
            }
        }
    }
</style>
<template>
    <div class="page_con no">
        <div class="page404" v-if="status == 'noresp'">
            <img src="../assets/images/network.png" alt="">
            <p>網絡異常，稍後再試</p>
            <div class="gohome" @click="$router.go(-1)">點擊刷新</div>
        </div>
        <div class="page404" v-if="status == 'page404'">
            <img src="../assets/images/wrong.png" alt="">
            <p>頁面出錯，稍後再試</p>
            <div class="gohome" @click="$router.push('/index')">返回首頁</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            status:'',
        }
    },
    mounted() {
        let type = this.$route.query.type;
        this.status = type?type:'page404';
    },
}
</script>


// WEBPACK FOOTER //
// src/components/notfound.vue